<template>

    <div class="learnworlds-button-wrapper lw-content-block learnworlds-element">
        <button class="learnworlds-button learnworlds-button-normal learnworlds-button-solid-accent1 learnworlds-element">
            <span>Get started</span>
        </button>
    </div>

</template>

<script>

    export default {
        data () {
            return {}
        }
    }
</script>
